import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';

// Enlaces a las 5 landing pages de servicio específico, para que Home y /services
// (las páginas con más autoridad de enlaces internos) les pasen equity de enlace.
const SERVICE_LINKS = [
  {
    path: '/enfermeria-24-horas',
    label: 'Enfermería 24 Horas',
    description: 'Cobertura continua para pacientes que requieren atención médica sin interrupciones.'
  },
  {
    path: '/cuidados-geriatricos',
    label: 'Cuidados Geriátricos',
    description: 'Atención integral y personalizada para adultos mayores en casa.'
  },
  {
    path: '/atencion-postoperatoria',
    label: 'Atención Postoperatoria',
    description: 'Recuperación segura y profesional después de una cirugía.'
  },
  {
    path: '/enfermeria-zapopan',
    label: 'Enfermería en Zapopan',
    description: 'Cobertura en todas las colonias de Zapopan.'
  },
  {
    path: '/enfermeria-tlaquepaque',
    label: 'Enfermería en Tlaquepaque',
    description: 'Atención en todo San Pedro Tlaquepaque.'
  },
  {
    path: '/servicios-expres',
    label: 'Servicios Exprés',
    description: 'Visitas de 1 a 3 horas para sueros, inyecciones o curaciones, sin contratar un turno completo.'
  }
];

function FeaturedServiceLinks({ title }) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">{title}</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICE_LINKS.map((service) => (
            <Link
              key={service.path}
              to={service.path}
              className="group bg-gray-50 hover:bg-blue-50 border border-gray-100 hover:border-blue-200 rounded-xl p-6 transition-colors"
            >
              <h3 className="font-bold text-gray-900 group-hover:text-blue-700 mb-2 flex items-center justify-between">
                {service.label}
                <FaArrowRight className="text-blue-500 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" />
              </h3>
              <p className="text-sm text-gray-600">{service.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

FeaturedServiceLinks.propTypes = {
  title: PropTypes.string
};

FeaturedServiceLinks.defaultProps = {
  title: 'Explora nuestros servicios por necesidad'
};

export default FeaturedServiceLinks;
